export class PreferredCountries{
  predefinedCountries: any;
  constructor(){
    this.predefinedCountries = [
      {
        name: 'United States',
        alpha2Code: 'US',
        alpha3Code: 'USA',
        numericCode: '840',
        callingCode: '+1'
      },
      {
        name: 'India',
        alpha2Code: 'IN',
        alpha3Code: 'IND',
        numericCode: '356',
        callingCode: '+91'
      },
      {
        name: 'United Kingdom',
        alpha2Code: 'GB',
        alpha3Code: 'GBR',
        numericCode: '826',
        callingCode: '+44'
      },
      {
        name: 'Germany',
        alpha2Code: 'DE',
        alpha3Code: 'DEU',
        numericCode: '276',
        callingCode: '+49'
      } 
    ];
   
  }
  get(){
      return this.predefinedCountries;
  }
}